import { useFormContext } from '@redwoodjs/forms'

export default function usePromoCodeEditor(close: () => void, name: string) {
  const { setValue } = useFormContext()

  const clearPromoCode = () => {
    for (const field of [
      'promoCodeCode',
      'promoCodeDiscount',
      'promoCodeValidFrom',
      'promoCodeValidTo',
    ]) {
      setValue(`${name}.${field}`, null)
    }
    close()
  }

  return { clearPromoCode }
}
